import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { CheckIcon, LightBulbIcon, ImagesIcon } from 'images'
import GenerateButton from './GenerateButton'
import LoaderSpinner from 'components/Shared/Loader/LoaderSpinner'

export default function CoCreatePanelHeader(props) {
  const {
    variant,
    isGenerateButtonDisabled,
    isPanelDisabled = false,
    setVariant,
    setSelectedSubGroupId,
    onGenerate,
    onViewVariants,
  } = props
  const { t } = useTranslation()

  const translationKey = `Recommendations.campaign.setup.coCreatePanel.tryCoCreate.${variant}`

  // return
  return (
    <div className={`co-create-panel-header ${variant}`}>

      <div className="co-create-description">
        <div className="co-create-icon-btn-wrapper">
          <div
            className="bt autofill_btn"
            style={{ width: 'fit-content', borderRadius: '10px' }}
            color="orange"
          >
            {variant === 'generating' ? <LoaderSpinner size="mini" style={{ padding: '2px' }}/> : <LightBulbIcon height={20} width={20} />}
          </div>

          {variant === 'ready' && (
            <span className="co-create-icon-btn__status" aria-hidden="true">
              <CheckIcon width={8} height={8} />
            </span>
          )}
        </div>

        <div>
          <p className="title">{t(`${translationKey}.title`)}</p>

          <p className="description">{t(`${translationKey}.description`)}</p>
        </div>
      </div>

      {variant === 'open' && (
        <div className="d-flex items-center gap-2 actions-wrapper">
          <button
            type="button"
            onClick={() => {
              setVariant('closed')
              setSelectedSubGroupId?.(null)
            }}
            className="cancel-button"
          > {t('common.cancel')}</button>

          <GenerateButton
            disabled={isGenerateButtonDisabled}
            onClick={onGenerate}
          />
        </div>
      )}

      {variant === 'closed' && (
        <GenerateButton
          disabled={isPanelDisabled}
          onClick={() => !isPanelDisabled && setVariant('open')}
        />
      )}

      {variant === 'generating' && (
        <GenerateButton
          loading
        />
      )}

      {variant === 'ready' && (
        <button
          onClick={onViewVariants}
          type="button"
          className="view-variants-button"
        >
          <ImagesIcon width={16} height={16} />

          <span className="text">{t('Recommendations.campaign.setup.coCreatePanel.viewVariants')}</span>
        </button>
      )}
    </div>
  )
}

CoCreatePanelHeader.propTypes = {
  variant: PropTypes.oneOf(['closed', 'open', 'generating', 'ready']).isRequired,
  setVariant: PropTypes.func.isRequired,
  isGenerateButtonDisabled: PropTypes.bool,
  isPanelDisabled: PropTypes.bool,
  setSelectedSubGroupId: PropTypes.func,
  onGenerate: PropTypes.func,
  onViewVariants: PropTypes.func,
}
